import { Variants } from '../types/variant';

const pages = {
  CONSULTATION: {
    title: 'Consultation',
    sections: ['CONTEXTE'],
    progressSteps: [1, 2, 4, 6],
  },
  COMPLAINTS: {
    title: 'Motif de consultation',
    sections: ['MOTIF'],
    progressSteps: [
      8, 16, 19, 22, 25, 28, 31, 34, 37, 40, 43, 46, 52, 55, 58, 61, 64, 67, 70,
      73, 76,
    ],
  },
  HISTORY: {
    title: 'Antécédents',
    sections: [
      'ANTECEDENTS', // deprecated after KB PR #846 is deployed
      'ATCD_NV_PATIENT',
      'ANTECEDENTS_GYNECO_NV_PATIENT',
      'ATCD_NV_PATIENT_FOLLOWUP',
      'ATCD_HEADER',
      'ATCD',
      'ANTECEDENTS_GYNECO',
      'ALD_DM',
      'ALLERMED',
      'TRAITEMENTS',
      'ATCD_MISC',
      'MENSURATION',
    ],
    progressSteps: [73, 75, 77, 79, 81, 83],
  },
  PREVENTION: {
    title: 'Prévention',
    sections: [
      'PREVENTION_UPDATE',
      'COMPLETE_PREVENTION',
      'PEDIATRIC_PREVENTION',
      'SCREENING_SPE',
      'PREVENTION_OPTIONAL',
    ],
    progressSteps: [
      84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
    ],
  },
  CONCLUSION: {
    title: 'Conclusion',
    sections: ['RECAP'],
    progressSteps: [100],
  },
};

export const genericSpeVariants = {
  specialiste: {
    name: 'Spécialiste',
    status: 'stable',
    description:
      'Questionnaire générique pour les patients de médecins spécialistes. Couvre les motifs, les antécédents personnels et familiaux du patient ainsi que la prévention.',
    speciality: 'GENERIC-SPE',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'MED_G_DEFAULT',
    initialQuestions: [] as string[],
    pages,
    initialAssertions: [
      "[Message: #‹]-(06.a_lieu_emission)->[Lieu]-(01.DESCR)->[Salle d'Attente]-(PART_OF)->[Cabinet Médical: #c]",
      '[Médecin: #z‹]-(a_spécialité)->[Médecine Générale]',
      '[Médecin: #z‹]-(a_habilitation)->[IVG médicamenteuse]',
    ],
    options: ['COMPACT', 'ALERTES'],
  },
} satisfies Variants;
